module.exports = __webpack_public_path__ + "static/media/Zombie Pirate.96808252.jpg";